import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-activity-config-group",
  "use": "icon-activity-config-group-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-activity-config-group\"><defs><style type=\"text/css\"></style></defs><path d=\"M938.666667 256v682.666667H256V256h682.666667z m-256 384h-170.666667a85.333333 85.333333 0 0 0-85.12 78.933333L426.666667 725.333333v42.666667a42.666667 42.666667 0 0 0 37.674666 42.368L469.333333 810.666667h256a42.666667 42.666667 0 0 0 42.368-37.674667L768 768v-42.666667a85.333333 85.333333 0 0 0-85.333333-85.333333z m85.333333-554.666667v85.333334H170.666667v597.333333H85.333333V85.333333h682.666667z m-170.666667 298.666667a85.333333 85.333333 0 1 0 0 170.666667 85.333333 85.333333 0 0 0 0-170.666667z\" p-id=\"2423\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/activity-config-group.svg
// module id = aYc+
// module chunks = 115